﻿/*global DataCoverage:true */

var DataCoverage = DataCoverage || {};

DataCoverage.countries = [
    {
        "iso3": "ABW",
        "iso2": "AW",
        "name": "Aruba",
        "grade": "Street"
    },
    {
        "iso3": "AFG",
        "iso2": "AF",
        "name": "Afghanistan",
        "grade": "Street"
    },
    {
        "iso3": "AGO",
        "iso2": "AO",
        "name": "Angola",
        "grade": "Locality"
    },
    {
        "iso3": "AIA",
        "iso2": "AI",
        "name": "Anguilla",
        "grade": "Locality"
    },
    {
        "iso3": "ALB",
        "iso2": "AL",
        "name": "Albania",
        "grade": "Building/House Number"
    },
    {
        "iso3": "AND",
        "iso2": "AD",
        "name": "Andorra",
        "grade": "Building/House Number"
    },
    /* "Netherlands Antilles" no longer exists. http://en.wikipedia.org/wiki/Netherlands_Antilles
    {
        "iso3": "ANT",
        "iso2": "AN",
        "name": "Netherlands Antilles",
        "grade": "Street"
    },*/
    {
        "iso3": "ARE",
        "iso2": "AE",
        "name": "United Arab Emirates",
        "grade": "Building/House Number"
    },
    {
        "iso3": "ARG",
        "iso2": "AR",
        "name": "Argentina",
        "grade": "Building/House Number"
    },
    {
        "iso3": "ARM",
        "iso2": "AM",
        "name": "Armenia",
        "grade": "Building/House Number"
    },
    {
        "iso3": "ASM",
        "iso2": "AS",
        "name": "American Samoa",
        "grade": "Locality"
    },
    {
        "iso3": "ATG",
        "iso2": "AG",
        "name": "Antigua and Barbuda",
        "grade": "Street"
    },
    {
        "iso3": "AUS",
        "iso2": "AU",
        "name": "Australia",
        "grade": "Delivery Point"
    },
    {
        "iso3": "AUT",
        "iso2": "AT",
        "name": "Austria",
        "grade": "Building/House Number"
    },
    {
        "iso3": "AZE",
        "iso2": "AZ",
        "name": "Azerbaijan",
        "grade": "Building/House Number"
    },
    {
        "iso3": "BDI",
        "iso2": "BI",
        "name": "Burundi",
        "grade": "Street"
    },
    {
        "iso3": "BEL",
        "iso2": "BE",
        "name": "Belgium",
        "grade": "Building/House Number"
    },
    {
        "iso3": "BEN",
        "iso2": "BJ",
        "name": "Benin",
        "grade": "Street"
    },
    {
        "iso3": "BES",
        "iso2": "BQ",
        "name": "Caribbean Netherlands",
        "grade": "Street"
    },
    {
        "iso3": "BFA",
        "iso2": "BF",
        "name": "Burkina Faso",
        "grade": "Street"
    },
    {
        "iso3": "BGD",
        "iso2": "BD",
        "name": "Bangladesh",
        "grade": "Street"
    },
    {
        "iso3": "BGR",
        "iso2": "BG",
        "name": "Bulgaria",
        "grade": "Building/House Number"
    },
    {
        "iso3": "BHR",
        "iso2": "BH",
        "name": "Bahrain",
        "grade": "Building/House Number"
    },
    {
        "iso3": "BHS",
        "iso2": "BS",
        "name": "Bahamas",
        "grade": "Building/House Number"
    },
    {
        "iso3": "BIH",
        "iso2": "BA",
        "name": "Bosnia and Herzegovina",
        "grade": "Building/House Number"
    },
    {
        "iso3": "BLM",
        "iso2": "BL",
        "name": "Saint Barthélemy",
        "grade": "Building/House Number"
    },
    {
        "iso3": "BLR",
        "iso2": "BY",
        "name": "Belarus",
        "grade": "Building/House Number"
    },
    {
        "iso3": "BLZ",
        "iso2": "BZ",
        "name": "Belize",
        "grade": "Street"
    },
    {
        "iso3": "BMU",
        "iso2": "BM",
        "name": "Bermuda",
        "grade": "Street"
    },
    {
        "iso3": "BOL",
        "iso2": "BO",
        "name": "Bolivia",
        "grade": "Street"
    },
    {
        "iso3": "BRA",
        "iso2": "BR",
        "name": "Brazil",
        "grade": "Building/House Number"
    },
    {
        "iso3": "BRB",
        "iso2": "BB",
        "name": "Barbados",
        "grade": "Street"
    },
    {
        "iso3": "BRN",
        "iso2": "BN",
        "name": "Brunei Darussalam",
        "grade": "Building/House Number"
    },
    {
        "iso3": "BTN",
        "iso2": "BT",
        "name": "Bhutan",
        "grade": "Street"
    },
    {
        "iso3": "BWA",
        "iso2": "BW",
        "name": "Botswana",
        "grade": "Street"
    },
    {
        "iso3": "CAF",
        "iso2": "CF",
        "name": "Central African Republic",
        "grade": "Street"
    },
    {
        "iso3": "CAN",
        "iso2": "CA",
        "name": "Canada",
        "grade": "Delivery Point"
    },
    {
        "iso3": "CCK",
        "iso2": "CC",
        "name": "Cocos Islands",
        "grade": "Street"
    },
    {
        "iso3": "CHE",
        "iso2": "CH",
        "name": "Switzerland",
        "grade": "Building/House Number"
    },
    {
        "iso3": "CHL",
        "iso2": "CL",
        "name": "Chile",
        "grade": "Building/House Number"
    },
    {
        "iso3": "CHN",
        "iso2": "CN",
        "name": "China",
        "grade": "Building/House Number"
    },
    {
        "iso3": "CIV",
        "iso2": "CI",
        "name": "Côte d'Ivoire",
        "grade": "Street"
    },
    {
        "iso3": "CMR",
        "iso2": "CM",
        "name": "Cameroon",
        "grade": "Street"
    },
    {
        "iso3": "COD",
        "iso2": "CD",
        "name": "Congo, The Democratic Republic of the",
        "grade": "Street"
    },
    {
        "iso3": "COG",
        "iso2": "CG",
        "name": "Congo",
        "grade": "Street"
    },
    {
        "iso3": "COK",
        "iso2": "CK",
        "name": "Cook Islands",
        "grade": "Street"
    },
    {
        "iso3": "COL",
        "iso2": "CO",
        "name": "Colombia",
        "grade": "Building/House Number"
    },
    {
        "iso3": "COM",
        "iso2": "KM",
        "name": "Comoros",
        "grade": "Street"
    },
    {
        "iso3": "CPV",
        "iso2": "CV",
        "name": "Cape Verde",
        "grade": "Street"
    },
    {
        "iso3": "CRI",
        "iso2": "CR",
        "name": "Costa Rica",
        "grade": "Building/House Number"
    },
    {
        "iso3": "CUB",
        "iso2": "CU",
        "name": "Cuba",
        "grade": "Street"
    },
    {
        "iso3": "CUW",
        "iso2": "CW",
        "name": "Curaçao",
        "grade": "Street"
    },
    {
        "iso3": "CXR",
        "iso2": "CX",
        "name": "Christmas Island",
        "grade": "Building/House Number"
    },
    {
        "iso3": "CYM",
        "iso2": "KY",
        "name": "Cayman Islands",
        "grade": "Building/House Number"
    },
    {
        "iso3": "CYP",
        "iso2": "CY",
        "name": "Cyprus",
        "grade": "Building/House Number"
    },
    {
        "iso3": "CZE",
        "iso2": "CZ",
        "name": "Czech Republic",
        "grade": "Building/House Number"
    },
    {
        "iso3": "DEU",
        "iso2": "DE",
        "name": "Germany",
        "grade": "Building/House Number"
    },
    {
        "iso3": "DJI",
        "iso2": "DJ",
        "name": "Djibouti",
        "grade": "Street"
    },
    {
        "iso3": "DMA",
        "iso2": "DM",
        "name": "Dominica",
        "grade": "Street"
    },
    {
        "iso3": "DNK",
        "iso2": "DK",
        "name": "Denmark",
        "grade": "Building/House Number"
    },
    {
        "iso3": "DOM",
        "iso2": "DO",
        "name": "Dominican Republic",
        "grade": "Street"
    },
    {
        "iso3": "DZA",
        "iso2": "DZ",
        "name": "Algeria",
        "grade": "Street"
    },
    {
        "iso3": "ECU",
        "iso2": "EC",
        "name": "Ecuador",
        "grade": "Building/House Number"
    },
    {
        "iso3": "EGY",
        "iso2": "EG",
        "name": "Egypt",
        "grade": "Building/House Number"
    },
    {
        "iso3": "ERI",
        "iso2": "ER",
        "name": "Eritrea",
        "grade": "Street"
    },
    {
        "iso3": "ESH",
        "iso2": "EH",
        "name": "Western Sahara",
        "grade": "Locality"
    },
    {
        "iso3": "ESP",
        "iso2": "ES",
        "name": "Spain",
        "grade": "Building/House Number"
    },
    {
        "iso3": "EST",
        "iso2": "EE",
        "name": "Estonia",
        "grade": "Building/House Number"
    },
    {
        "iso3": "ETH",
        "iso2": "ET",
        "name": "Ethiopia",
        "grade": "Locality"
    },
    {
        "iso3": "FIN",
        "iso2": "FI",
        "name": "Finland",
        "grade": "Building/House Number"
    },
    {
        "iso3": "FJI",
        "iso2": "FJ",
        "name": "Fiji",
        "grade": "Street"
    },
    {
        "iso3": "FLK",
        "iso2": "FK",
        "name": "Falkland Islands",
        "grade": "Street"
    },
    {
        "iso3": "FRA",
        "iso2": "FR",
        "name": "France",
        "grade": "Delivery Point"
    },
    {
        "iso3": "FRO",
        "iso2": "FO",
        "name": "Faroe Islands",
        "grade": "Building/House Number"
    },
    {
        "iso3": "FSM",
        "iso2": "FM",
        "name": "Micronesia, Federated States of",
        "grade": "Street"
    },
    {
        "iso3": "GAB",
        "iso2": "GA",
        "name": "Gabon",
        "grade": "Street"
    },
    {
        "iso3": "GBR",
        "iso2": "GB",
        "name": "United Kingdom",
        "grade": "Delivery Point"
    },
    {
        "iso3": "GEO",
        "iso2": "GE",
        "name": "Georgia",
        "grade": "Street"
    },
    {
        "iso3": "GBR",
        "iso2": "GG",
        "name": "Guernsey",
        "grade": "Delivery Point"
    },
    {
        "iso3": "GHA",
        "iso2": "GH",
        "name": "Ghana",
        "grade": "Street"
    },
    {
        "iso3": "GIB",
        "iso2": "GI",
        "name": "Gibraltar",
        "grade": "Building/House Number"
    },
    {
        "iso3": "GIN",
        "iso2": "GN",
        "name": "Guinea",
        "grade": "Street"
    },
    {
        "iso3": "GLP",
        "iso2": "GP",
        "name": "Guadeloupe",
        "grade": "Building/House Number"
    },
    {
        "iso3": "GMB",
        "iso2": "GM",
        "name": "Gambia",
        "grade": "Street"
    },
    {
        "iso3": "GNB",
        "iso2": "GW",
        "name": "Guinea-Bissau",
        "grade": "Street"
    },
    {
        "iso3": "GNQ",
        "iso2": "GQ",
        "name": "Equatorial Guinea",
        "grade": "Street"
    },
    {
        "iso3": "GRC",
        "iso2": "GR",
        "name": "Greece",
        "grade": "Building/House Number"
    },
    {
        "iso3": "GRD",
        "iso2": "GD",
        "name": "Grenada",
        "grade": "Street"
    },
    {
        "iso3": "GRL",
        "iso2": "GL",
        "name": "Greenland",
        "grade": "Building/House Number"
    },
    {
        "iso3": "GTM",
        "iso2": "GT",
        "name": "Guatemala",
        "grade": "Street"
    },
    {
        "iso3": "GUF",
        "iso2": "GF",
        "name": "French Guiana",
        "grade": "Building/House Number"
    },
    {
        "iso3": "GUM",
        "iso2": "GU",
        "name": "Guam",
        "grade": "Building/House Number"
    },
    {
        "iso3": "GUY",
        "iso2": "GY",
        "name": "Guyana",
        "grade": "Street"
    },
    {
        "iso3": "HKG",
        "iso2": "HK",
        "name": "Hong Kong",
        "grade": "Building/House Number"
    },
    {
        "iso3": "HND",
        "iso2": "HN",
        "name": "Honduras",
        "grade": "Street"
    },
    {
        "iso3": "HRV",
        "iso2": "HR",
        "name": "Croatia",
        "grade": "Building/House Number"
    },
    {
        "iso3": "HTI",
        "iso2": "HT",
        "name": "Haiti",
        "grade": "Street"
    },
    {
        "iso3": "HUN",
        "iso2": "HU",
        "name": "Hungary",
        "grade": "Building/House Number"
    },
    {
        "iso3": "IDN",
        "iso2": "ID",
        "name": "Indonesia",
        "grade": "Building/House Number"
    },
    {
        "iso3": "GBR",
        "iso2": "IM",
        "name": "Isle of Man",
        "grade": "Delivery Point"
    },
    {
        "iso3": "IND",
        "iso2": "IN",
        "name": "India",
        "grade": "Building/House Number"
    },
    {
        "iso3": "IRL",
        "iso2": "IE",
        "name": "Ireland",
        "grade": "Building/House Number"
    },
    {
        "iso3": "IRN",
        "iso2": "IR",
        "name": "Iran, Islamic Republic of",
        "grade": "Street"
    },
    {
        "iso3": "IRQ",
        "iso2": "IQ",
        "name": "Iraq",
        "grade": "Street"
    },
    {
        "iso3": "ISL",
        "iso2": "IS",
        "name": "Iceland",
        "grade": "Building/House Number"
    },
    {
        "iso3": "ISR",
        "iso2": "IL",
        "name": "Israel",
        "grade": "Building/House Number"
    },
    {
        "iso3": "ITA",
        "iso2": "IT",
        "name": "Italy",
        "grade": "Building/House Number"
    },
    {
        "iso3": "JAM",
        "iso2": "JM",
        "name": "Jamaica",
        "grade": "Street"
    },
    {
        "iso3": "GBR",
        "iso2": "JE",
        "name": "Jersey",
        "grade": "Delivery Point"
    },
    {
        "iso3": "JOR",
        "iso2": "JO",
        "name": "Jordan",
        "grade": "Building/House Number"
    },
    {
        "iso3": "JPN",
        "iso2": "JP",
        "name": "Japan",
        "grade": "Building/House Number"
    },
    {
        "iso3": "KAZ",
        "iso2": "KZ",
        "name": "Kazakhstan",
        "grade": "Building/House Number"
    },
    {
        "iso3": "KEN",
        "iso2": "KE",
        "name": "Kenya",
        "grade": "Street"
    },
    {
        "iso3": "KGZ",
        "iso2": "KG",
        "name": "Kyrgyzstan",
        "grade": "Street"
    },
    {
        "iso3": "KHM",
        "iso2": "KH",
        "name": "Cambodia",
        "grade": "Street"
    },
    {
        "iso3": "KIR",
        "iso2": "KI",
        "name": "Kiribati",
        "grade": "Locality"
    },
    {
        "iso3": "KNA",
        "iso2": "KN",
        "name": "Saint Kitts and Nevis",
        "grade": "Street"
    },
    {
        "iso3": "KOR",
        "iso2": "KR",
        "name": "Korea, Republic of",
        "grade": "Unsupported"
    },
    {
        "iso3": "KOS",
        "iso2": "XK",
        "name": "Kosovo",
        "grade": "Street"
    },
    {
        "iso3": "KWT",
        "iso2": "KW",
        "name": "Kuwait",
        "grade": "Building/House Number"
    },
    {
        "iso3": "LAO",
        "iso2": "LA",
        "name": "Lao, People's Democratic Republic",
        "grade": "Street"
    },
    {
        "iso3": "LBN",
        "iso2": "LB",
        "name": "Lebanon",
        "grade": "Building/House Number"
    },
    {
        "iso3": "LBR",
        "iso2": "LR",
        "name": "Liberia",
        "grade": "Street"
    },
    {
        "iso3": "LBY",
        "iso2": "LY",
        "name": "Libyan Arab Jamahiriya",
        "grade": "Street"
    },
    {
        "iso3": "LCA",
        "iso2": "LC",
        "name": "Saint Lucia",
        "grade": "Street"
    },
    {
        "iso3": "LIE",
        "iso2": "LI",
        "name": "Liechtenstein",
        "grade": "Building/House Number"
    },
    {
        "iso3": "LKA",
        "iso2": "LK",
        "name": "Sri Lanka",
        "grade": "Locality"
    },
    {
        "iso3": "LSO",
        "iso2": "LS",
        "name": "Lesotho",
        "grade": "Street"
    },
    {
        "iso3": "LTU",
        "iso2": "LT",
        "name": "Lithuania",
        "grade": "Building/House Number"
    },
    {
        "iso3": "LUX",
        "iso2": "LU",
        "name": "Luxembourg",
        "grade": "Building/House Number"
    },
    {
        "iso3": "LVA",
        "iso2": "LV",
        "name": "Latvia",
        "grade": "Building/House Number"
    },
    {
        "iso3": "MAC",
        "iso2": "MO",
        "name": "Macau",
        "grade": "Building/House Number"
    },
    {
        "iso3": "MAF",
        "iso2": "MF",
        "name": "Saint Martin",
        "grade": "Street"
    },
    {
        "iso3": "MAR",
        "iso2": "MA",
        "name": "Morocco",
        "grade": "Building/House Number"
    },
    {
        "iso3": "MCO",
        "iso2": "MC",
        "name": "Monaco",
        "grade": "Building/House Number"
    },
    {
        "iso3": "MDA",
        "iso2": "MD",
        "name": "Moldova",
        "grade": "Building/House Number"
    },
    {
        "iso3": "MDG",
        "iso2": "MG",
        "name": "Madagascar",
        "grade": "Street"
    },
    {
        "iso3": "MDV",
        "iso2": "MV",
        "name": "Maldives",
        "grade": "Street"
    },
    {
        "iso3": "MEX",
        "iso2": "MX",
        "name": "Mexico",
        "grade": "Building/House Number"
    },
    {
        "iso3": "MHL",
        "iso2": "MH",
        "name": "Marshall Islands",
        "grade": "Street"
    },
    {
        "iso3": "MKD",
        "iso2": "MK",
        "name": "Macedonia, The Former Yugoslav Republic of",
        "grade": "Building/House Number"
    },
    {
        "iso3": "MLI",
        "iso2": "ML",
        "name": "Mali",
        "grade": "Street"
    },
    {
        "iso3": "MLT",
        "iso2": "MT",
        "name": "Malta",
        "grade": "Street"
    },
    {
        "iso3": "MMR",
        "iso2": "MM",
        "name": "Myanmar",
        "grade": "Street"
    },
    {
        "iso3": "MNE",
        "iso2": "ME",
        "name": "Montenegro",
        "grade": "Building/House Number"
    },
    {
        "iso3": "MNG",
        "iso2": "MN",
        "name": "Mongolia",
        "grade": "Locality"
    },
    {
        "iso3": "MNP",
        "iso2": "MP",
        "name": "Northern Mariana Islands",
        "grade": "Street"
    },
    {
        "iso3": "MOZ",
        "iso2": "MZ",
        "name": "Mozambique",
        "grade": "Street"
    },
    {
        "iso3": "MRT",
        "iso2": "MR",
        "name": "Mauritania",
        "grade": "Street"
    },
    {
        "iso3": "MSR",
        "iso2": "MS",
        "name": "Montserrat",
        "grade": "Street"
    },
    {
        "iso3": "MTQ",
        "iso2": "MQ",
        "name": "Martinique",
        "grade": "Building/House Number"
    },
    {
        "iso3": "MUS",
        "iso2": "MU",
        "name": "Mauritius",
        "grade": "Street"
    },
    {
        "iso3": "MWI",
        "iso2": "MW",
        "name": "Malawi",
        "grade": "Street"
    },
    {
        "iso3": "MYS",
        "iso2": "MY",
        "name": "Malaysia",
        "grade": "Building/House Number"
    },
    {
        "iso3": "MYT",
        "iso2": "YT",
        "name": "Mayotte",
        "grade": "Building/House Number"
    },
    {
        "iso3": "NAM",
        "iso2": "NA",
        "name": "Namibia",
        "grade": "Building/House Number"
    },
    {
        "iso3": "NCL",
        "iso2": "NC",
        "name": "New Caledonia",
        "grade": "Building/House Number"
    },
    {
        "iso3": "NCY",
        "iso2": "??",
        "name": "Turkish Republic of Northern Cyprus",
        "grade": "Building/House Number"
    },
    {
        "iso3": "NER",
        "iso2": "NE",
        "name": "Niger",
        "grade": "Street"
    },
    {
        "iso3": "NFK",
        "iso2": "NF",
        "name": "Norfolk Island",
        "grade": "Building/House Number"
    },
    {
        "iso3": "NGA",
        "iso2": "NG",
        "name": "Nigeria",
        "grade": "Street"
    },
    {
        "iso3": "NIC",
        "iso2": "NI",
        "name": "Nicaragua",
        "grade": "Street"
    },
    {
        "iso3": "NIU",
        "iso2": "NU",
        "name": "Niue",
        "grade": "Street"
    },
    {
        "iso3": "NLD",
        "iso2": "NL",
        "name": "Netherlands",
        "grade": "Building/House Number"
    },
    {
        "iso3": "NOR",
        "iso2": "NO",
        "name": "Norway",
        "grade": "Building/House Number"
    },
    {
        "iso3": "NPL",
        "iso2": "NP",
        "name": "Nepal",
        "grade": "Street"
    },
    {
        "iso3": "NRU",
        "iso2": "NR",
        "name": "Nauru",
        "grade": "Locality"
    },
    {
        "iso3": "NZL",
        "iso2": "NZ",
        "name": "New Zealand",
        "grade": "Delivery Point"
    },
    {
        "iso3": "OMN",
        "iso2": "OM",
        "name": "Oman",
        "grade": "Building/House Number"
    },
    {
        "iso3": "PAK",
        "iso2": "PK",
        "name": "Pakistan",
        "grade": "Street"
    },
    {
        "iso3": "PAN",
        "iso2": "PA",
        "name": "Panama",
        "grade": "Building/House Number"
    },
    {
        "iso3": "PCN",
        "iso2": "PN",
        "name": "Pitcairn Islands",
        "grade": "Locality"
    },
    {
        "iso3": "PER",
        "iso2": "PE",
        "name": "Peru",
        "grade": "Building/House Number"
    },
    {
        "iso3": "PHL",
        "iso2": "PH",
        "name": "Philippines",
        "grade": "Building/House Number"
    },
    {
        "iso3": "PLW",
        "iso2": "PW",
        "name": "Palau",
        "grade": "Street"
    },
    {
        "iso3": "PNG",
        "iso2": "PG",
        "name": "Papua New Guinea",
        "grade": "Street"
    },
    {
        "iso3": "POL",
        "iso2": "PL",
        "name": "Poland",
        "grade": "Building/House Number"
    },
    {
        "iso3": "PSE",
        "iso2": "PS",
        "name": "Palestine",
        "grade": "Locality"
    },
    {
        "iso3": "USA",
        "iso2": "PR",
        "name": "Puerto Rico",
        "grade": "Delivery Point"
    },
    {
        "iso3": "PRK",
        "iso2": "KP",
        "name": "Korea, Democratic People's Republic of",
        "grade": "Locality"
    },
    {
        "iso3": "PRT",
        "iso2": "PT",
        "name": "Portugal",
        "grade": "Building/House Number"
    },
    {
        "iso3": "PRY",
        "iso2": "PY",
        "name": "Paraguay",
        "grade": "Building/House Number"
    },
    {
        "iso3": "PYF",
        "iso2": "PF",
        "name": "French Polynesia",
        "grade": "Street"
    },
    {
        "iso3": "QAT",
        "iso2": "QA",
        "name": "Qatar",
        "grade": "Building/House Number"
    },
    {
        "iso3": "REU",
        "iso2": "RE",
        "name": "Réunion",
        "grade": "Building/House Number"
    },
    {
        "iso3": "ROU",
        "iso2": "RO",
        "name": "Romania",
        "grade": "Building/House Number"
    },
    {
        "iso3": "RUS",
        "iso2": "RU",
        "name": "Russian Federation",
        "grade": "Building/House Number"
    },
    {
        "iso3": "RWA",
        "iso2": "RW",
        "name": "Rwanda",
        "grade": "Locality"
    },
    {
        "iso3": "SAU",
        "iso2": "SA",
        "name": "Saudi Arabia",
        "grade": "Building/House Number"
    },
    {
        "iso3": "SDN",
        "iso2": "SD",
        "name": "Sudan",
        "grade": "Locality"
    },
    {
        "iso3": "SEN",
        "iso2": "SN",
        "name": "Senegal",
        "grade": "Street"
    },
    {
        "iso3": "SGP",
        "iso2": "SG",
        "name": "Singapore",
        "grade": "Delivery Point"
    },
    {
        "iso3": "SGS",
        "iso2": "GS",
        "name": "South Georgia and the South Sandwich Islands",
        "grade": "Locality"
    },
    {
        "iso3": "SHN",
        "iso2": "SH",
        "name": "Saint Helena",
        "grade": "Street"
    },
    {
        "iso3": "SJM",
        "iso2": "SJ",
        "name": "Svalbard and Jan Mayen",
        "grade": "Street"
    },
    {
        "iso3": "SLB",
        "iso2": "SB",
        "name": "Solomon Islands",
        "grade": "Street"
    },
    {
        "iso3": "SLE",
        "iso2": "SL",
        "name": "Sierra Leone",
        "grade": "Street"
    },
    {
        "iso3": "SLV",
        "iso2": "SV",
        "name": "El Salvador",
        "grade": "Street"
    },
    {
        "iso3": "SMR",
        "iso2": "SM",
        "name": "San Marino",
        "grade": "Building/House Number"
    },
    {
        "iso3": "SOM",
        "iso2": "SO",
        "name": "Somalia",
        "grade": "Locality"
    },
    {
        "iso3": "SPM",
        "iso2": "PM",
        "name": "Saint Pierre and Miquelon",
        "grade": "Street"
    },
    {
        "iso3": "SRB",
        "iso2": "RS",
        "name": "Serbia",
        "grade": "Building/House Number"
    },
    {
        "iso3": "SSD",
        "iso2": "SS",
        "name": "South Sudan",
        "grade": "Street"
    },
    {
        "iso3": "STP",
        "iso2": "ST",
        "name": "Sao Tome and Principe",
        "grade": "Street"
    },
    {
        "iso3": "SUR",
        "iso2": "SR",
        "name": "Suriname",
        "grade": "Building/House Number"
    },
    {
        "iso3": "SVK",
        "iso2": "SK",
        "name": "Slovakia",
        "grade": "Building/House Number"
    },
    {
        "iso3": "SVN",
        "iso2": "SI",
        "name": "Slovenia",
        "grade": "Building/House Number"
    },
    {
        "iso3": "SWE",
        "iso2": "SE",
        "name": "Sweden",
        "grade": "Building/House Number"
    },
    {
        "iso3": "SWZ",
        "iso2": "SZ",
        "name": "Swaziland",
        "grade": "Street"
    },
    {
        "iso3": "SXM",
        "iso2": "SX",
        "name": "Sint Maarten",
        "grade": "Street"
    },
    {
        "iso3": "SYC",
        "iso2": "SC",
        "name": "Seychelles",
        "grade": "Locality"
    },
    {
        "iso3": "SYR",
        "iso2": "SY",
        "name": "Syrian Arab Republic",
        "grade": "Street"
    },
    {
        "iso3": "TCA",
        "iso2": "TC",
        "name": "Turks and Caicos Islands",
        "grade": "Unsupported"
    },
    {
        "iso3": "TCD",
        "iso2": "TD",
        "name": "Chad",
        "grade": "Street"
    },
    {
        "iso3": "TGO",
        "iso2": "TG",
        "name": "Togo",
        "grade": "Street"
    },
    {
        "iso3": "THA",
        "iso2": "TH",
        "name": "Thailand",
        "grade": "Building/House Number"
    },
    {
        "iso3": "TJK",
        "iso2": "TJ",
        "name": "Tajikistan",
        "grade": "Street"
    },
    {
        "iso3": "TKL",
        "iso2": "TK",
        "name": "Tokelau",
        "grade": "Locality"
    },
    {
        "iso3": "TKM",
        "iso2": "TM",
        "name": "Turkmenistan",
        "grade": "Street"
    },
    {
        "iso3": "TLS",
        "iso2": "TL",
        "name": "Timor-Leste",
        "grade": "Street"
    },
    {
        "iso3": "TON",
        "iso2": "TO",
        "name": "Tonga",
        "grade": "Street"
    },
    {
        "iso3": "TTO",
        "iso2": "TT",
        "name": "Trinidad and Tobago",
        "grade": "Street"
    },
    {
        "iso3": "TUN",
        "iso2": "TN",
        "name": "Tunisia",
        "grade": "Building/House Number"
    },
    {
        "iso3": "TUR",
        "iso2": "TR",
        "name": "Turkey",
        "grade": "Building/House Number"
    },
    {
        "iso3": "TUV",
        "iso2": "TV",
        "name": "Tuvalu",
        "grade": "Locality"
    },
    {
        "iso3": "TWN",
        "iso2": "TW",
        "name": "Taiwan",
        "grade": "Building/House Number"
    },
    {
        "iso3": "TZA",
        "iso2": "TZ",
        "name": "Tanzania",
        "grade": "Street"
    },
    {
        "iso3": "UGA",
        "iso2": "UG",
        "name": "Uganda",
        "grade": "Street"
    },
    {
        "iso3": "UKR",
        "iso2": "UA",
        "name": "Ukraine",
        "grade": "Building/House Number"
    },
    {
        "iso3": "URY",
        "iso2": "UY",
        "name": "Uruguay",
        "grade": "Building/House Number"
    },
    {
        "iso3": "USA",
        "iso2": "US",
        "name": "United States",
        "grade": "Delivery Point"
    },
    {
        "iso3": "UZB",
        "iso2": "UZ",
        "name": "Uzbekistan",
        "grade": "Street"
    },
    {
        "iso3": "VAT",
        "iso2": "VA",
        "name": "Holy See",
        "grade": "Street"
    },
    {
        "iso3": "VCT",
        "iso2": "VC",
        "name": "Saint Vincent and the Grenadines",
        "grade": "Locality"
    },
    {
        "iso3": "VEN",
        "iso2": "VE",
        "name": "Venezuela",
        "grade": "Street"
    },
    {
        "iso3": "VGB",
        "iso2": "VG",
        "name": "Virgin Islands, British",
        "grade": "Street"
    },
    {
        "iso3": "VIR",
        "iso2": "VI",
        "name": "Virgin Islands, U.S.",
        "grade": "Building/House Number"
    },
    {
        "iso3": "VNM",
        "iso2": "VN",
        "name": "Viet Nam",
        "grade": "Building/House Number"
    },
    {
        "iso3": "VUT",
        "iso2": "VU",
        "name": "Vanuatu",
        "grade": "Sreet"
    },
    {
        "iso3": "WLF",
        "iso2": "WF",
        "name": "Wallis and Futuna",
        "grade": "Locality"
    },
    {
        "iso3": "WSM",
        "iso2": "WS",
        "name": "Samoa",
        "grade": "Street"
    },
    {
        "iso3": "YEM",
        "iso2": "YE",
        "name": "Yemen",
        "grade": "Locality"
    },
    {
        "iso3": "ZAF",
        "iso2": "ZA",
        "name": "South Africa",
        "grade": "Building/House Number"
    },
    {
        "iso3": "ZMB",
        "iso2": "ZM",
        "name": "Zambia",
        "grade": "Street"
    },
    {
        "iso3": "ZWE",
        "iso2": "ZW",
        "name": "Zimbabwe",
        "grade": "Street"
    }
];